import {
  FaOilCan,
  FaBuilding,
  FaCity,
  FaCubes,
  FaLeaf,
  FaClipboardCheck,
} from "react-icons/fa";

const services = [
  {
    id: "01",
    title: "Oil & Gas Engineering",
    slug: "oil-gas",
    desc: "Engineering Solutions for Critical Industrial Infrastructure",
    icon: <FaOilCan />,
    image: "/assets/images/services/service1.jpg",
    content: `
      <p>
        We provide specialized structural engineering, BIM, and construction support services for the Oil & Gas, Petrochemical, Refinery, and Process Industries. We understand that industrial facilities demand the highest standards of safety, reliability, and engineering precision.
      </p>

      <p>
        Our engineering team delivers robust, code-compliant, and constructible solutions designed to withstand complex operational loads, dynamic equipment forces, seismic effects, wind loads, and harsh environmental conditions while ensuring long-term structural performance.
      </p>

      <p>
        From conceptual engineering to detailed design, BIM coordination, fabrication drawings, and site engineering support, we work closely with EPC contractors, consultants, fabricators, and industrial clients throughout every stage of the project lifecycle.
      </p>
    `,
  },

  {
    id: "02",
    title: "Pre-Engineered Buildings",
    slug: "pre-engineered-buildings",
    desc: "Fast. Efficient. Engineered to Perform.",
    icon: <FaBuilding />,
    image: "/assets/images/services/service2.jpg",
    content: `
      <p>
Pre-Engineered Buildings (PEB) are the preferred solution for modern industrial and commercial infrastructure, offering faster construction, optimized steel consumption, and long-term structural performance. Our Design & Build approach provides clients with a single point of responsibility—from concept planning and structural engineering to fabrication, erection, and project execution.      </p>

      <p>
With expertise in long-span PEB portal frames and material-optimized engineering, every structure is designed to reduce steel consumption, minimize fabrication waste, and maximize usable space without compromising safety or quality.      </p>

      <p>
Our solutions cater to warehouses, manufacturing plants, logistics parks, factories, aircraft hangars, commercial buildings, and industrial facilities, delivering cost-effective, fabrication-friendly, and code-compliant structures that ensure faster project completion and superior performance.

      </p>
    `,
  },

  {
    id: "03",
    title: "Real Estate",
    slug: "real-estate",
    desc: "Engineered for Modern Skylines. Designed for Lasting Performance.",
    icon: <FaCity />,
    image: "/assets/images/services/service3.jpg",
    content: `
      <p>
Modern real estate developments demand structural engineering that balances safety, efficiency, aesthetics, and cost optimization. We provide comprehensive structural engineering and BIM consultancy for residential, commercial, mixed-use, and institutional developments, transforming architectural concepts into safe, buildable, and high-performance structures.

      </p>

      <p>
Our expertise includes the design of RCC high-rise buildings, residential towers, commercial complexes, mixed-use developments, hotels, hospitals, educational institutions, podiums, basements, transfer girders, flat slabs, post-tensioned slabs, shear wall systems, core wall structures, cantilever structures, and earthquake-resistant buildings.
      </p>

      <p>
From concept design and structural analysis to BIM coordination, construction drawings, and site engineering support, we deliver technically sound, economical, and code-compliant engineering solutions that optimize structural performance, simplify construction, and create long-lasting value.      </p>
    `,
  },

  {
    id: "04",
    title: "Building Information Modeling (BIM)",
    slug: "bim-services",
    desc: "Digital Engineering. Smarter Project Delivery.",
    icon: <FaCubes />,
    image: "/assets/images/services/service4.png",
    content: `
      <p>
Building Information Modeling (BIM) is transforming the construction industry by enabling better collaboration, improved coordination, and greater project efficiency. We provide end-to-end BIM consultancy that integrates design, engineering, and construction workflows into a coordinated digital environment, reducing errors, minimizing rework, and enhancing project delivery.      </p>

      <p>
Our expertise includes BIM implementation, 3D modeling, multidisciplinary coordination, clash detection, Revit modeling, Tekla Structures, shop drawings, scan-to-BIM, as-built modeling, quantity take-offs, and LOD 100–LOD 500 BIM deliverables for residential, commercial, industrial, infrastructure, and oil & gas projects.      </p>

      <p>
From design development to construction documentation and digital project coordination, we deliver accurate, intelligent, and standards-compliant BIM solutions that improve visualization, streamline execution, and support informed decision-making throughout the project lifecycle.      </p>
    `,
  },

  {
    id: "05",
    title: "Sustainable Design & Engineering",
    slug: "sustainable-design",
    desc: "Engineering a Smarter, More Sustainable Future.",
    icon: <FaLeaf />,
    image: "/assets/images/services/service5.webp",
    content: `
      <p>
Sustainable engineering is about creating structures that are efficient, resilient, and environmentally responsible without compromising performance or functionality. We deliver sustainable design and engineering solutions that optimize structural systems, reduce material consumption, improve energy efficiency, and support cost-effective construction throughout the project lifecycle.      </p>

      <p>
Our approach integrates value engineering, material optimization, low-carbon structural solutions, efficient foundation design, lifecycle performance, and BIM-driven coordination to minimize waste, enhance constructability, and maximize long-term asset value. Every design is developed with a focus on safety, durability, resource efficiency, and compliance with modern engineering standards.      </p>

      <p>
From concept development to detailed engineering, we help clients deliver sustainable buildings and infrastructure that balance environmental responsibility with technical excellence and commercial viability.      </p>
    `,
  },

  {
    id: "06",
    title: "Structural Audit",
    slug: "structural-audit",
    desc: "Assessing Strength. Ensuring Safety. Extending Asset Life.",
    icon: <FaClipboardCheck />,
    image: "/assets/images/services/service6.webp",
    content: `
      <p>
Structural integrity is essential for the safety, performance, and longevity of any building or infrastructure. We provide comprehensive Structural Audit services to evaluate the condition, stability, and serviceability of existing structures, helping clients identify potential risks and make informed decisions for repair, rehabilitation, or strengthening.      </p>

      <p>
Our expertise includes visual inspections, structural assessment, condition surveys, Non-Destructive Testing (NDT) coordination, load evaluation, crack analysis, durability assessment, structural stability verification, and retrofitting recommendations for residential, commercial, industrial, and institutional buildings.      </p>

      <p>
Using advanced engineering analysis and industry best practices, we deliver detailed audit reports with practical recommendations to ensure regulatory compliance, enhance structural safety, extend the service life of assets, and protect long-term investments.      </p>
    `,
  },
];

export default services;